<template>
  <header id="home" class="gradient-violat">
        <nav class="navbar navbar-default navbar-fixed-top">
          <div class="container">
          <!-- Brand and toggle get grouped for better mobile display -->
            <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" href="#"><span class="logo-wraper logo-white">
                  <img src="images/Logo.png" alt="">{{headData.logo_title}}
                </span></a>
            </div>
  
            <!-- Collect the nav links, forms, and other content for toggling -->
            <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              <ul class="nav navbar-nav  navbar-right">
                <li class="active"><a href="#home">{{headData.header_home}} <span class="sr-only">(current)</span></a></li>
                <li><a href="#newsList">{{headData.header_news}}</a></li>
                <li><a href="#testimonial">{{headData.header_about}}</a></li>
                <li><a href="#services">{{headData.header_product}}</a></li>
                <li><a href="#newsletter">{{headData.header_contact}}</a></li>
                <li><a href="#customer-support">{{headData.header_recruit}}</a></li>
                <li @click="changeLanguage"><a href="#" class="btn btn-orange border-none btn-rounded-corner btn-navbar">{{headData.header_language}}<span class="icon-on-button"></span></a></li>
              </ul>
            </div><!-- /.navbar-collapse -->
            <hr class="navbar-divider">
          </div><!-- /.container-fluid -->
        </nav>
      </header>
      
</template>

<script>
export default {
  name: 'homehead',
  props:['headData', 'changeLanguage'],
  
}
</script>


// WEBPACK FOOTER //
// src/components/header.vue